import { Helmet } from "./SEO";

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
  noIndex?: boolean;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogImage, ogType = "website", schema, noIndex }: SEOProps) {
  const fullTitle = title.includes("黑料王") ? title : `${title} - 黑料王`;
  const siteUrl = "https://heiliaowang.com";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={canonicalUrl || siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl || siteUrl} />
      <meta property="og:site_name" content="黑料王" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

function Helmet({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const existingTitle = document.querySelector("title");
    const existingMeta: Element[] = [];
    const existingLinks: Element[] = [];
    const existingScripts: Element[] = [];

    const childrenArray = React.Children.toArray(children) as React.ReactElement[];

    childrenArray.forEach((child) => {
      if (child.type === "title") {
        document.title = child.props.children;
      } else if (child.type === "meta") {
        const el = document.createElement("meta");
        Object.keys(child.props).forEach((key) => {
          el.setAttribute(key, child.props[key]);
        });
        document.head.appendChild(el);
        existingMeta.push(el);
      } else if (child.type === "link") {
        const el = document.createElement("link");
        Object.keys(child.props).forEach((key) => {
          el.setAttribute(key, child.props[key]);
        });
        document.head.appendChild(el);
        existingLinks.push(el);
      } else if (child.type === "script") {
        const el = document.createElement("script");
        el.type = "application/ld+json";
        el.textContent = child.props.children;
        document.head.appendChild(el);
        existingScripts.push(el);
      }
    });

    return () => {
      existingMeta.forEach((el) => el.remove());
      existingLinks.forEach((el) => el.remove());
      existingScripts.forEach((el) => el.remove());
    };
  }, [children]);

  return null;
}